export default __webpack_public_path__ + "static/_/shared/assets/images/404-dark.png";